import _ from "lodash";

export const buildSearchParamsString = (base, paramsObj) => {
    let out = base;

    const validParams = Object.entries(paramsObj).filter(([key, value]) => value != null)
    if (validParams.length !== 0)
        out += `?${new URLSearchParams(Object.fromEntries(validParams)).toString()}`;

    return out;
}

export const buildEndpointUri = (base, { page, limit, sort, searchTerm } = { page: 1, limit: 25, sort: null, searchTerm: null }) => {
    let uri = `${base}?page=${page}&limit=${limit}`;
    if (sort) {
        uri += `&sort=${sort}`;
    }
    if (searchTerm) {
        uri += `&searchTerm=${encodeURI(searchTerm)}`;
    }
    return uri;
};

export const useCacheKeyMergeHandler = (currentCache, newItems) => {
    if (_.isEqual(currentCache.cacheKey, newItems.cacheKey)) {
        currentCache.pagination = newItems.pagination;
        currentCache.results.push(...newItems.results);
    }
    else {
        currentCache.newRecordsSinceCache = 0;
        currentCache.cacheKey = newItems.cacheKey;
        currentCache.pagination = newItems.pagination;
        currentCache.results = [...newItems.results];
    }
};

export const useCacheKeyTransformResponseHandler = (response, _, { cacheKey }) => {
    return { cacheKey, newRecordsSinceCache: 0, ...response };
};

export const useCacheKeySerializeQueryArgsHandler = ({ endpointName }) => {
    return endpointName;
};